import { apiUser } from "../../../api/api-users";
// import { CAR_STATUS, TRANSMISSION_TYPE } from '../../../common/utils/static-data';
import { alert } from "../../../common/utils/alert";
import { emitter } from "../../../common/utils/emitter";
import moment from "moment";

export const submit = (
  context,
  isModal,
  visiableOkButtonOnModal,
  setCustomerOnModal
) => {
  context.form
    .validateFields()
    .then(async (values) => {
      if (!isModal) {
        emitter.emit("FETCH_LOADING", true);
      } else {
        visiableOkButtonOnModal(true);
      }

      let dto = {
        active: values.user_status ? false : true,
        branch_id: values.permission_area,
        code: values.signup_name,
        department_id: values.department,
        name: values.account_name,
        user_role_id: values.roles,
        password:
          context.state.typeOption === "edit" && context.state.checkEditPass
            ? values.password
            : null,
        id: context.state.userIdEdit ? context.state.userIdEdit : null,
      };
      if (context.state.typeOption === "create_new") {
        try {
          const result = await apiUser.createNewUser(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Thêm tài khoản thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      } else {
        try {
          const result = await apiUser.updateUser(dto);
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
          if (result.status === "success") {
            if (isModal) {
              setCustomerOnModal(result.data);
            }
            alert("success", "Cập nhật tài khoản thành công!");
            context.props.close && context.props.close();
          } else {
            alert("error", result.data.message);
          }
        } catch (error) {
          if (!isModal) {
            emitter.emit("FETCH_LOADING", false);
          } else {
            visiableOkButtonOnModal(false);
          }
        }
      }
    })
    .catch((err) => {});
};

export const userConvert = async (user, context) => {
  context.form.setFieldsValue({
    account_name: user.name,
    signup_name: user.code,
    user_status: user.active ? 0 : 1,
    signup_name: user.code,
    roles: user.user_role.id,
    permission_area: user.branch ? user.branch.id : null,
    department: user.department ? user.department.id : null,
  });
};
